import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core";
import { Colors } from "../../helpers/theme";
import StakingRewardsBg from "../../assets/images/stakingRewardsBg.png";

const useStyles = makeStyles((theme) => ({
  locktokens: {
    "& h2": {
      [theme.breakpoints.down("md")]: {
        marginBottom: "12px",
        fontSize: theme.typography.body1.fontSize,
        "& span": {
          fontSize: theme.typography.body1.fontSize,
        },
      },
    },

    "& .mainBox": {
      fontFamily: "Oxygen, sans-serif",
      background: Colors.white,
      maxWidth: "190px",
      marginLeft: "auto",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
        marginLeft: "0",
        borderRadius: "0",
        marginTop: theme.spacing(3),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        border: "0",
        position: "relative",
        "&:before": {
          content: "''",
          position: "absolute",
          top: "0",
          left: "0",
          right: "0",
          width: "100%",
          height: "1px",
          backgroundColor: "#11302D",
          opacity: "0.1",
        },
        "&:after": {
          content: "''",
          position: "absolute",
          bottom: "0",
          left: "0",
          right: "0",
          width: "100%",
          height: "1px",
          backgroundColor: "#11302D",
          opacity: "0.1",
        },
      },
      "& hr": {
        margin: theme.spacing(1, 0, 4, 0),
      },
      "&.totaltickets": {
        maxWidth: "100%",
        height: "300px",
        overflowY: "scroll",
        "&::-webkit-scrollbar": {
          width: "4px",
        },
        "&::-webkit-scrollbar-track": {},
        "&::-webkit-scrollbar-thumb": {
          borderRadius: "10px",
          background: "#ECF0F3 ",
        },
      },
    },
    // changes

    "& .availablebalance": {
      "& .MuiOutlinedInput-input": {
        minWidth: "264px",
        [theme.breakpoints.down("sm")]: {},
      },
    },
    "& .select-gains-dropdown": {
      width: "45%",
      [theme.breakpoints.down("sm")]: {
        minWidth: "100%",
      },
    },
    "& .btn-medium": {
      paddingTop: "10px",
      paddingBottom: "10px",
      paddingRight: theme.spacing(6),
      paddingLeft: theme.spacing(6),
    },
    "& .img-icon": {
      marginRight: "1px",
    },
    "& .divider": {
      marginRight: theme.spacing(1.5),
    },

    "& .MuiPopover-root": {
      color: "red",
    },
    "& .back-btn": {
      "& .MuiButton-label": {
        fontSize: "12px",
      },
      "& .MuiButton-startIcon": {
        marginRight: "4px",
      },
    },
  },

  stakeModalTitle: {
    fontSize: "1.375rem",
    fontWeight: 700,
    color: Colors.black,
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      marginBottom: ".5rem",
    },
  },
  durationLabel: {
    fontSize: "0.875rem",
    fontWeight: 700,
    lineHeight: "17.68px",
    color: Colors.darkSlate,
    marginTop: ".25rem",
  },
  bonusLabel: {
    color: "rgba(107, 130, 153, 0.7)",
    fontSize: "11px",
    lineHeight: "13.89px",
    fontWeight: 700,
    marginTop: "0.25rem",
  },
  durationInput: {
    width: "1rem",
    cursor: "pointer",
    color: "rgba(17, 48, 45, 0.3)",
    backgrounColor: Colors.greenLight,
    border: "none !important",
    height: "1rem",
  },

  tierLabel: {
    fontSize: "0.8125rem",
    fontWeight: 700,
    color: "rgba(17, 48, 45, 0.5)",
    marginBottom: "0.2rem",
  },

  tierValue: {
    fontWeight: 700,
    fontSize: "1.375rem",
    color: Colors.black,
    lineHeight: "20px",
  },

  learnMore: {
    color: Colors.darkSlate,
    fontSize: "0.875rem",
    fontWeight: 700,
  },

  QuizBtn: {
    width: "100%",
    marginTop: "24px",
    background: "linear-gradient(87.43deg, #3EB8AA -0.62%, #3eb8aa 119.91%)",
    color: "#ffffff",
    textAlign: "center",
  },
  RequiresBtn: {
    width: "100%",
    marginTop: "24px",
    background: "linear-gradient(87.43deg, #3EB8AA -0.62%, #3eb8aa 119.91%)",
    color: "#ffffff",
    textAlign: "center",
  },
  disabledButton: {
    width: "100%",
    marginTop: "24px",
    background: "linear-gradient(87.43deg, #3EB8AA -0.62%, #3eb8aa 119.91%)",
    color: "#ffffff !important",
    opacity: "0.5",
    textAlign: "center",
  },
  durationBtn: {
    minWidth: "25%",
    margin: "0 5px",
    // padding: "5px 15px",
    color: "#415957",
    fontSize: "6px",
    backgroundColor: "rgba(48, 127, 226, 0.05);",
  },
  activeDurationBtn: {
    minWidth: "25%",
    margin: "0 2px",
    color: "#ffffff",
    fontSize: "6px",
    backgroundColor: "#3EB8AA",
    "&:hover": {
      backgroundColor: "#3EB8AA",
    },
  },
  stakingBtn: {
    marginTop: "30px",
    width: "100%",
    backgroundColor: "#3EB8AA",
    color: "#ffffff",
    textAlign: "center",
    "&:hover": {
      color: "#3EB8AA",
      backgroundColor: "#ffffff",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  youtube: {
    background: "#e52d27",
    color: "#ffffff",
    width: "100%",
  },
  lockActionCard: {
    height: "auto",
    backgroundImage: `url(${StakingRewardsBg})`,
    padding: "1.875rem",
  },
  lockActionCardSm: {
    backgroundImage: `url(${StakingRewardsBg})`,
    padding: "1rem",
  },
  lockSupportCard: {
    background: "#dcdcdc",
    height: "100%",
  },
  lockSupprtCardFloat: {
    position: "fixed",
    bottom: "10px",
    right: "10px",
    zIndex: 99,
  },
  lockAccordion: {
    fontFamily: "Oxygen, sans-serif",
    border: "0px",
    borderRadius: "0px",
    borderBottom: "1px solid",
  },
  ticketsBox: {
    background: "#3EB8AA",
    boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1.25rem",
    position: "relative",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      padding: ".75rem",
    },
    "& p": {
      fontSize: "14px",
      marginBottom: "0",
      fontWeight: 700,
      color: "rgba(255, 255, 255, 0.8)",
    },
    "& h3": {
      fontSize: "22px",
      color: "#ffffff",
      fontWeight: 700,
    },
    "& .ticket-logo": {
      position: "absolute",
      top: 0,
      marginTop: "-.7rem",
      marginRight: "-.7rem",
      [theme.breakpoints.down("sm")]: {
        width: "3rem",
        marginTop: "-1rem",
        marginRight: "-1rem",
      },
      right: 0,
    },
  },
  ticketsBox1: {
    backgroundColor: "#3EB8AA",
    boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    display: "fkex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "140px",
    "& p": {
      fontsize: "14px",
      marginTop: "20px",
      marginLeft: "20px",
      color: "rgba(255, 255, 255, 0.8)",
      [theme.breakpoints.down("sm")]: {
        marginLeft: ".7rem",
      },
    },
    "& h3": {
      fontSize: "28px",
      color: "#ffffff",
      marginLeft: "20px",
      [theme.breakpoints.down("sm")]: {
        marginLeft: ".7rem",
      },
    },
    "& .ticket-logo": {
      marginTop: "-15px",
      marginRight: "-15px",
    },
    [theme.breakpoints.down("md")]: {
      boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.02)",
    },
  },
  successRate: {
    background: "#ffffff",
    zIndex: 10,
    border: "1px solid rgba(17, 48, 45, 0.08)",
    boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1.25rem",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      padding: ".75rem",
    },
    "& p": {
      fontSize: "14px",
      fontWeight: 700,
      marginBottom: "0",
      color: "rgba(17, 48, 45, 0.5)",
    },
    "& h3": {
      fontSize: "22px",
      color: Colors.black,
      fontWeight: 700,
    },
  },
  successRate1: {
    backgroundColor: "#fffff",
    marginTop: "30px",
    border: "1px solid #307FE226",
    boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    width: "100%",
    height: "140px",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    "& p": {
      fontsize: "14px",
      marginTop: "20px",
      marginLeft: "20px",
      color: "rgba(17, 48, 45, 0.5)",
      [theme.breakpoints.down("sm")]: {
        marginLeft: ".7rem",
      },
    },
    "& h3": {
      fontSize: "28px",
      color: "#000000",
      marginLeft: "20px",
      marginBottom: "20px",

      [theme.breakpoints.down("sm")]: {
        marginLeft: ".7rem",
      },
    },
    [theme.breakpoints.down("md")]: {
      marginTop: 0,
      boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.02)",
    },
  },
}));

const sliderStyle = makeStyles((theme) => ({
  durationslider: {
    "& .lockbox": {
      background: Colors.white,
      borderRadius: "36px",
      padding: "35px 22px",
      maxWidth: "220px",
      margin: "0 auto",
      textAlign: "center",
      minHeight: "400px",
      transition: "all 0.5s ease-in-out",
      "&:hover , &.active": {
        transition: "all 0.5s ease-in-out",
        transform: "scale(1.2)",
        filter: "drop-shadow(0px 14px 79px rgba(17, 48, 45, 0.11))",
        [theme.breakpoints.down("md")]: {
          transform: "scale(1)",
          filter: "none",
        },
        "& .MuiTypography-h3": {
          transition: "all 0.5s ease-in-out",
          color: Colors.green,
        },
        "& .MuiButton-containedSizeLarge": {
          transition: "opacity 0.5s ease-in-out",
          visibility: "visible",
          opacity: "1",
        },
        "& img": {
          transition: "filter 0.5s ease-in-out",
          filter: "unset",
        },
      },
      [theme.breakpoints.down("xs")]: {
        padding: "35px 0 35px 0",
        maxWidth: "99%",

        minHeight: "auto",
        "& .MuiTypography-h3": {
          transition: "all 1s ease-in-out",
          color: Colors.green,
        },
      },
      "& .fs12": {
        fontSize: theme.typography.subtitle1.fontSize,
      },
    },
    "& .slick-track": {
      padding: "60px 0",
      [theme.breakpoints.down("md")]: {
        padding: "8px 0 64px 0",
      },
    },
    "& .slick-slide": {
      textAlign: "center",
      outline: "none",
      "& div": {
        outline: "none",
      },
      [theme.breakpoints.up("md")]: {
        opacity: "0",
        visibility: "hidden",
      },
      "& img": {
        maxWidth: "200px",
        margin: "0 auto 24px auto",
        filter: "grayscale(100%)",
        [theme.breakpoints.down("md")]: {
          filter: "unset",
        },
      },
      "& .MuiButton-containedSizeLarge": {
        visibility: "hidden",
        opacity: "0",
        minWidth: "160px",
        marginTop: theme.spacing(5),
        [theme.breakpoints.down("md")]: {
          visibility: "visible",
          opacity: "1",
        },
      },
    },
    "& .slick-list": {
      [theme.breakpoints.up("md")]: {
        overflow: "visible",
      },
    },
    "& .slick-slider": {
      "& .slick-active": {
        [theme.breakpoints.up("md")]: {
          opacity: "1",
          visibility: "visible",
        },
      },
      "& .slick-dots": {
        bottom: "18px",
        "& li button:before": {
          fontSize: "18px",
          opacity: "1",
          color: "#8CA2B7",
        },
        "& li.slick-active button:before": {
          color: Colors.green,
        },
      },
    },
  },
}));

export { useStyles, sliderStyle };
